export default {
  id: "multiplayer-fps-cpp",
  pride: 10240,
  slug: "multiplayer-fps-cpp",
  category: "game",
  status: "released",
  titleKey: {
    zh: "联机FPS（纯C++）",
    en: "Multiplayer FPS (Pure C++)"
  },
  bilibiliVideoId: "BV1Ge4y1a7WC",
  date: { year: 2022, month: 9, day: 10 },
  descriptionKey: {
    zh: "联机FPS游戏，游戏逻辑用C++手写。",
    en: "Multiplayer FPS game with all game logic written in pure C++."
  },
  genres: ["FPS", "联机"],
  themes: ["射击", "C++"],
  engine: "虚幻引擎",
  platform: ["PC"],
  developerNotesKey: {
    zh: "联机FPS，用C++写了游戏逻辑。",
    en: "Multiplayer FPS with game logic written in C++."
  },
  tags: ["C++", "联机"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1Ge4y1a7WC/", textKey: { zh: "B站视频", en: "Bilibili Video" } }
  ]
};
